import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Calendar = function Calendar(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$secondaryColor = _ref.secondaryColor,
    secondaryColor = _ref$secondaryColor === void 0 ? '#00D1FF' : _ref$secondaryColor,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 48 48",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M40 45H8C5.8 45 4 43.2 4 41V10C4 7.8 5.8 6 8 6H40C42.2 6 44 7.8 44 10V41C44 43.2 42.2 45 40 45ZM8 8C6.9 8 6 8.9 6 10V41C6 42.1 6.9 43 8 43H40C41.1 43 42 42.1 42 41V10C42 8.9 41.1 8 40 8H8Z",
      fill: !ignoreColor ? color : undefined
    }), /*#__PURE__*/_jsx("path", {
      d: "M36 3H34V11H36V3Z",
      fill: !ignoreColor ? color : undefined
    }), /*#__PURE__*/_jsx("path", {
      d: "M14 3H12V11H14V3Z",
      fill: !ignoreColor ? color : undefined
    }), /*#__PURE__*/_jsx("path", {
      d: "M43 16H5V18H43V16Z",
      fill: !ignoreColor ? color : undefined
    }), /*#__PURE__*/_jsx("path", {
      d: "M17 23H10V25H17V23Z",
      fill: !ignoreColor ? secondaryColor : undefined
    }), /*#__PURE__*/_jsx("path", {
      d: "M27 23H20V25H27V23Z",
      fill: !ignoreColor ? secondaryColor : undefined
    }), /*#__PURE__*/_jsx("path", {
      d: "M37 23H30V25H37V23Z",
      fill: !ignoreColor ? secondaryColor : undefined
    }), /*#__PURE__*/_jsx("path", {
      d: "M17 30H10V32H17V30Z",
      fill: !ignoreColor ? secondaryColor : undefined
    }), /*#__PURE__*/_jsx("path", {
      d: "M27 30H20V32H27V30Z",
      fill: !ignoreColor ? secondaryColor : undefined
    }), /*#__PURE__*/_jsx("path", {
      d: "M37 30H30V32H37V30Z",
      fill: !ignoreColor ? secondaryColor : undefined
    }), /*#__PURE__*/_jsx("path", {
      d: "M17 37H10V39H17V37Z",
      fill: !ignoreColor ? secondaryColor : undefined
    }), /*#__PURE__*/_jsx("path", {
      d: "M27 37H20V39H27V37Z",
      fill: !ignoreColor ? secondaryColor : undefined
    }), /*#__PURE__*/_jsx("path", {
      d: "M37 37H30V39H37V37Z",
      fill: !ignoreColor ? secondaryColor : undefined
    })]
  });
};
export default Calendar;